import { mapFormAdditionalTaxResponse } from "./AdditionalTax/RemoteConfig";
import { mapInitResponse } from "./Init/RemoteConfig";
import { mapFormMaxLeaseLoanResponse } from "./MaxLeaseLoan/RemoteConfig";
import { remoteClearError, remoteClearResponse } from "./RemoteActions";
import { RemoteConfig, RemoteScope } from "./RemoteTypes";
import { mapFormStandAloneResponse } from "./StandAlone/RemoteConfig";

const DEFAULTOBJECTPRICE = 20000;

/**
 *
 */
export const RemoteConfigs: { [K in RemoteScope]: RemoteConfig<K> } = {
    [RemoteScope.INIT]: {
        scope: RemoteScope.INIT,
        method: "GET",
        onInit: (d, _s, _ctx) => {
            d(remoteClearResponse(RemoteScope.INIT));
            d(remoteClearError(RemoteScope.INIT));
        },
        paramsMapper: (_s, ctx) => ({
            channel: ctx.channel,
        }),
        pathMapper: (_s, ctx) => {
            if (ctx.route === "max-lease") {
                return "/maxLease";
            } else if (ctx.route === "max-loan") {
                return "/maxLoan";
            } else if (ctx.route === "financial-lease") {
                return "/financialLease";
            } else if (ctx.route === "additional-tax") {
                return "/additionalTax";
            } else {
                return "";
            }
        },
        resMapper: mapInitResponse,
    },
    [RemoteScope.MAX_LEASE_POST]: {
        scope: RemoteScope.MAX_LEASE_POST,
        method: "POST",
        onInit: (d, _s, _ctx) => {
            d(remoteClearResponse(RemoteScope.MAX_LEASE_POST));
            d(remoteClearError(RemoteScope.MAX_LEASE_POST));
        },
        paramsMapper: (_s, ctx) => ({
            channel: ctx.channel ?? "",
        }),
        pathMapper: (_s, _ctx) => "/maxLease",
        bodyMapper: (_s, ctx) => ctx.form,
        resMapper: mapFormMaxLeaseLoanResponse,
    },
    [RemoteScope.MAX_LOAN_POST]: {
        scope: RemoteScope.MAX_LOAN_POST,
        method: "POST",
        onInit: (d, _s, _ctx) => {
            d(remoteClearResponse(RemoteScope.MAX_LOAN_POST));
            d(remoteClearError(RemoteScope.MAX_LOAN_POST));
        },
        paramsMapper: (_s, ctx) => ({
            channel: ctx.channel ?? "",
        }),
        pathMapper: (_s, _ctx) => "/maxLoan",
        bodyMapper: (_s, ctx) => ctx.form,
        resMapper: mapFormMaxLeaseLoanResponse,
    },
    [RemoteScope.FINANCIAL_LEASE_POST]: {
        scope: RemoteScope.FINANCIAL_LEASE_POST,
        method: "POST",
        pathMapper: (_s, _ctx) => "/financialLease",
        // pathMapper: (_s, _ctx) => "/financial-lease", // for connecting to mockoon
        paramsMapper: (_s, ctx) => ({
            channel: ctx.params.channel ?? "",
        }),
        bodyMapper: (_s, ctx) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { channel, ...filteredParamsWithoutChannel } = ctx.params;
            if(ctx.isInit) {
                const request = {
                    ...filteredParamsWithoutChannel,
                    /**
                     * @note When it's init, we should not only read it out from the params
                     * But we should also look if we already have it in the form,
                     * because you can also initialize whenever you switch the core fields, like
                     * finance type, and object price
                     * @author Nick
                     */
                    financeType: ctx.form.financeType ?? filteredParamsWithoutChannel.financeType,
                    objectPriceInclVATInclBPM: ctx.form.objectPriceInclVATInclBPM
                        ?? filteredParamsWithoutChannel.objectPriceInclVATInclBPM ?? DEFAULTOBJECTPRICE,
                    objectPriceExclVATExclBPM: ctx.form.objectPriceExclVATExclBPM
                        ?? filteredParamsWithoutChannel.objectPriceExclVATExclBPM,
                    financeTypeToggle: filteredParamsWithoutChannel.financeType === null ? true : false,
                };
                return (request);
            } else {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { channel,
                    financeType,
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    objectPriceExclVATExclBPM,
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    objectPriceInclVATInclBPM,
                    ...filteredParamsWithoutChannelAndFinanceType } = ctx.params;
                return ({
                    ...ctx.form,
                    ...filteredParamsWithoutChannelAndFinanceType,
                    financeTypeToggle: financeType === null ? true : false,
                });
            }
        },
        resMapper: mapFormStandAloneResponse,
    },
    [RemoteScope.ADDITIONAL_TAX_POST]: {
        scope: RemoteScope.ADDITIONAL_TAX_POST,
        method: "POST",
        onInit: (d, _s, _ctx) => {
            d(remoteClearResponse(RemoteScope.ADDITIONAL_TAX_POST));
            d(remoteClearError(RemoteScope.ADDITIONAL_TAX_POST));
        },
        paramsMapper: (_s, ctx) => ({
            channel: ctx.channel ?? "",
        }),
        pathMapper: (_s, _ctx) => "/additionalTax",
        bodyMapper: (_s, ctx) => ctx.form,
        resMapper: mapFormAdditionalTaxResponse,
    },
};
